import PublicPageTemplate from '../../components/PublicPageTemplate/PublicPageTemplate';

function TermsOfUseScreen() {
  return (
    <PublicPageTemplate title="Terms of use" fullWidth>
      <p className="govuk-body">Last updated: 11 February 2026</p>

      <p className="govuk-body">
        These terms apply to how you use GRID GovReturns.
      </p>
      <p className="govuk-body">
        You accept these terms when you create an account and by continuing to use the service.
      </p>
      <p className="govuk-body">
        If you do not keep to these terms, we may deactivate your account and remove access to your
        forms.
      </p>

      <h2 className="govuk-heading-m">Security</h2>
      <p className="govuk-body">
        You and your organisation are responsible for deciding if GRID GovReturns is suitable for
        the information you want to collect. Do not use this service to collect data classified as
        Secret or Top Secret.
      </p>
      <p className="govuk-body">
        You must follow your organisation&apos;s policies for using online tools and platforms.
      </p>

      <h3 className="govuk-heading-s">Accessing the service</h3>
      <p className="govuk-body">You must sign in using:</p>
      <ul className="govuk-list govuk-list--bullet">
        <li>a secure work-managed device</li>
        <li>a secure work email address protected with multi-factor authentication (MFA)</li>
        <li>a trusted internet connection</li>
      </ul>

      <h3 className="govuk-heading-s">Receiving completed form data</h3>
      <p className="govuk-body">
        Completed form data must only be sent to secure government email addresses that are
        restricted to relevant users.
      </p>
      <p className="govuk-body">
        You must check submitted data before use. Responses are user-entered and may contain errors
        or unsafe content.
      </p>

      <h3 className="govuk-heading-s">Report security breaches</h3>
      <p className="govuk-body">
        Report any security incidents immediately to{' '}
        <a className="govuk-link" href="mailto:report@digital.cabinet-office.gov.uk">
          report@digital.cabinet-office.gov.uk
        </a>
        .
      </p>

      <h2 className="govuk-heading-m">Data protection</h2>
      <p className="govuk-body">
        You must ensure your use of GRID GovReturns complies with data protection law and your
        organisation&apos;s policies for collecting, processing and storing personal data.
      </p>
      <p className="govuk-body">
        Your organisation is the data controller for data collected through forms you create in this
        service.
      </p>
      <p className="govuk-body">
        For compliance support, contact your organisation&apos;s data protection officer or data
        protection team.
      </p>

      <h2 className="govuk-heading-m">Changes to these terms</h2>
      <p className="govuk-body">
        We may update these terms. Where needed, we will let users know about material changes.
      </p>

      <h2 className="govuk-heading-m">Contact</h2>
      <p className="govuk-body">
        For service support, contact Cabinet Office Digital, GRID GovReturns Team at{' '}
        <a className="govuk-link" href="mailto:grid-platform@cabinetoffice.gov.uk">
          grid-platform@cabinetoffice.gov.uk
        </a>
        .
      </p>
    </PublicPageTemplate>
  );
}

export default TermsOfUseScreen;
